export class Apipath {
    public static Languagepath = 'api/Languages/GetLanguage/';
}
